import { pushActions } from 'features/Messaging/messaging-helpers'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { sendPushSubcription } from '../actions/push'
import { pushPublicKey } from '../services/config'
import { urlB64ToUint8Array } from '../utils/helpers'

function useServiceWorker() {
  const isLoggedIn = useSelector(s => s.login.userLoggedIn)

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    function handleServiceWorkerMessage(event) {
      const { action } = event.data

      if (action === pushActions.NavigateTo) {
        history.push(event.data.path)
      }
    }

    async function sendPushSubscriptionToServiceWorker() {
      if (
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        window.Notification
      ) {
        navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage)

        const serviceWorker = await navigator.serviceWorker.ready

        if (Notification.permission === 'granted') {
          const subscription = await serviceWorker.pushManager.getSubscription()

          if (subscription) {
            dispatch(sendPushSubcription(subscription.toJSON()))
          } else {
            const subscription = await serviceWorker.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlB64ToUint8Array(pushPublicKey)
            })
            dispatch(sendPushSubcription(subscription.toJSON()))
          }
        }
      }
    }

    if (
      'serviceWorker' in navigator &&
      'PushManager' in window &&
      window.Notification &&
      isLoggedIn
    ) {
      sendPushSubscriptionToServiceWorker()
    }

    return () =>
      navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage)
  }, [dispatch, history, isLoggedIn])
}

export default useServiceWorker
